import moment from "moment";
import React from "react";
import { IoMdBookmarks } from "@react-icons/all-files/io/IoMdBookmarks";
import { RiTimerFill } from "@react-icons/all-files/ri/RiTimerFill";

import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import Loadingnovel from "../../../components/Loadingnovel";

function Suggestion({ novel }) {
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
    delay: 100,
  });
  return (
    <Link
      to={`/novels/${novel._id}`}
      title={novel.title}
      ref={ref}
      className="flex flex-col shrink "
    >
      <div className="group  cursor-pointer p-0 sm:p-[6px] relative novel-hover  bg-primary">
        <div className="image-effect ">
          {inView ? (
            <div className="rectangle w-full h-full group-hover:scale-110 group-hover:opacity-80 duration-500 ease-in-out object-cover">
              <img
                className="rectangle w-full h-full group-hover:scale-110 group-hover:opacity-80 duration-500 ease-in-out object-cover"
                src={novel.selectedFile}
                alt={novel.title}
              />
            </div>
          ) : (
            <div className="flex justify-center items-center bg-secondary opacity-20 rectangle duration-[0] ease-in-out object-cover">
              <Loadingnovel />
            </div>
          )}
          <div className="absolute text-tertiary sm:group-hover:top-0 top-0 sm:-top-10 duration-500 ease-in-out flex justify-center items-center w-fit px-4 h-[32px] bg-primary space-x-[4px] font-SoraR">
            <IoMdBookmarks />
            <span className="text-[14px] sm:text[16px]">
              {novel.chaptersLength
                ? novel.chaptersLength < 10
                  ? "00" + novel.chaptersLength
                  : novel.chaptersLength > 99
                  ? novel.chaptersLength
                  : "0" + novel.chaptersLength
                : "000"}
            </span>
          </div>
          <div className="absolute text-primary -bottom-10 sm:group-hover:bottom-0 sm:-bottom-10 group-hover:bottom-0 duration-500 ease-in-out right-0 flex justify-center items-center w-fit px-4 h-[32px] bg-tertiary space-x-[8px] uppercase font-SoraR">
            <RiTimerFill className="flex-none" />
            <span className=" text-primary font-SoraR text-[10px] sm:text-[13px] line-clamp-1 break-all w-full">
              {moment(novel.createdAt).fromNow()}
            </span>
          </div>
        </div>
        <div className="mt-0 sm:mt-[12px] p-4 sm:p-0 mb-0 sm:mb-[8px] space-y-0 sm:space-y-[6px]">
          <div className="line-clamp-1">
            <h2 className="text-tertiary break-words text-center sm:text-left capitalize text-[14px] sm:pb-0 pb-0 sm:text-[16px] font-SoraR">
              {novel.title}
            </h2>
          </div>
          <div className="w-full   h-[0.5px] hidden sm:block bg-tertiary/20"></div>
          <div className="line-clamp-2">
            <p className="text-tertiary break-all hidden sm:block capitalize  text-[13px] font-SoraL   ">
              {novel.description}
            </p>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default Suggestion;
